import { render, staticRenderFns } from "./TransferCompanyEntity.vue?vue&type=template&id=c4b33f6a&"
import script from "./TransferCompanyEntity.vue?vue&type=script&lang=js&"
export * from "./TransferCompanyEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4b33f6a')) {
      api.createRecord('c4b33f6a', component.options)
    } else {
      api.reload('c4b33f6a', component.options)
    }
    module.hot.accept("./TransferCompanyEntity.vue?vue&type=template&id=c4b33f6a&", function () {
      api.rerender('c4b33f6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TransferCompanyEntity.vue"
export default component.exports